// extracted by mini-css-extract-plugin
module.exports = {"firstSeriesInAppH5":"FirstSeriesInApp_firstSeriesInAppH5__aKEwH"};